import React from 'react';

function ContactAddress() {
  return (
    <div className="col-xl-5 col-lg-6 col-md-8">

      <div className="contact-info-wrap">
        <div className="contact-img">
          <img src="img/images/dog-calling.jpg" alt="" />
        </div>
        <div className="contact-info-list">
          <ul>

            <li>
              <div className="icon"><i className="fas fa-phone-alt" /></div>
              <div className="content">
                <p>(+216) 53 666 149</p>
              </div>
            </li>
            <li>
              <div className="icon"><i className="fas fa-envelope-open" /></div>
              <div className="content">
                <p>contact@kaki.tn</p>
              </div>
            </li>
          </ul>
        </div>

        <div className="contact-social">
          <ul style={{ display: 'flex', justifyContent: 'center' }}>
            <li><a href="/#"><i className="fab fa-facebook-f" style={{ backgroundColor: '#1877F2' }} /></a></li>
            <li><a href="/#"><i className="fab fa-instagram" style={{ backgroundColor: '#E1306C' }} /></a></li>
            <li><a href="/#"><i className="fab fa-tiktok" style={{ backgroundColor: '#000000' }} /></a></li>
          </ul>
        </div>
      </div>
    </div>

  )
}

export default ContactAddress;
